module.exports = __webpack_public_path__ + "static/media/8OLA12.c5ebb99e.jpg";